export default __webpack_public_path__ + "static/media/Arch_Elastic-Load-Balancing_64.8a1ac222.svg";